// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"22392fb7","54":"64bb828b","145":"64bb828b","154":"113f90e8","389":"64bb828b","403":"64bb828b","406":"22392fb7","486":"22392fb7","697":"64bb828b","958":"e05e5866","974":"d1ed09df"}[chunkId] + ".chunk.css";
};